import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import Utilities from "../../dependencies/custom/react-utilities";
import domainSettings from "../../dependencies/custom/settings";

/**
 * Hook for fetching terms from the backend
 */
const useTerms = () => {
  const navigate = useNavigate();
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(false);

  /**
   * Fetch all terms from database
   */
  const fetchTerms = useCallback(async () => {
    setLoading(true);
    try {
      const response = await Utilities.fetchWithAuth(
        "GET",
        domainSettings.urls.enrollment.terms,
        null,
        navigate,
      );

      if (response.ok) {
        setTerms(response.data || []);
      } else {
        Utilities.showError(response, "Failed to fetch terms");
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
      message.error("An error occurred while fetching terms");
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  return {
    terms,
    loading,
    fetchTerms,
  };
};

export default useTerms;
